export class PaymentInstallments {
  identificadorPlan: string = ""
  mombre: string = ""
  monto: number = 0
}

export class CrossSell {
  plan?: string = ""
  cotizacion?: {
    ae?: {
      precioAutoEfectivo: number
      montoCoberturaRobo: number
      precioMesAutoEfectivo: number
    }
    trf?: {
      tipoCambio: number
      sol: {
        primaTotal: number
        pagoPlazos: PaymentInstallments[]
      }
      dolar: {
        primaTotal: number
        pagoPlazos: PaymentInstallments[]
      }
    }
  } | null = null
}

export class CrossSellResponse {
  datos: CrossSell = {}
}
